module.exports = __webpack_public_path__ + "static/media/lock.6f6f3bf3.svg";